<ngx-panel
	class="task-instruction-panel"
	[class.task-instruction-panel--inline]="showInlineEditor()">
	<panel-heading>
		<div class="title ellipsis">
			<span translate="task-details_instructions"></span>
		</div>
		<ngx-toolbar>
			<ngx-toolbar-button
				[ariaLabel]="'task-details_instructions_preview_button' | translate"
				[action]="toolbarActions.PREVIEW"
				(clicked)="preview()">
			</ngx-toolbar-button>
			@if (!showInlineEditor()) {
				<ngx-toolbar-button
					[ariaLabel]="'task-details_instructions_edit_button' | translate"
					[action]="toolbarActions.EDIT"
					(clicked)="edit()">
				</ngx-toolbar-button>
			}
			<ngx-toolbar-button
				class="task-instruction-remove-btn"
				[ariaLabel]="'task-details_instructions_delete_button' | translate"
				[action]="toolbarActions.REMOVE"
				(clicked)="remove()">
			</ngx-toolbar-button>
		</ngx-toolbar>
	</panel-heading>

	<panel-body>
		@if (showInlineEditor()) {
			<div class="instructions-editor">
				@if (shouldRenderInlineEditor()) {
					<ngx-rich-text-editor
						class="inline-task-instructions-editor"
						[autoFocus]="true"
						[content]="editorInstructionsHtml()"
						[hasRightButton]="true"
						placeholder="{{ 'activity-instructions-editor-modal-enter-instructions-here' | translate }}"
						(updateEvent)="handleEditorTextUpdate($event)"
						(onEditorFocusOut)="handleEditorFocusOut($event)">
					</ngx-rich-text-editor>
				}
				@if (media()) {
					<button
						type="button"
						class="link-btn remove-video-instructions-btn instructions-editor-toolbar-action"
						[attr.aria-label]="'activity-editor-instructions_remove-video-instructions' | translate"
						[attr.title]="'activity-editor-instructions_remove-video-instructions' | translate"
						(click)="openRemoveMediaInstructionsModal()">
						<i class="ficon-app-delete" aria-hidden="true"></i>
						<span
							class="instructions-editor-toolbar-action-label"
							translate="activity-editor-instructions_remove-video-instructions">
						</span>
					</button>
				} @else {
					<button
						type="button"
						class="link-btn add-btn add-video-instructions-btn instructions-editor-toolbar-action"
						[attr.aria-label]="'task-details_add_video_instructions_aria_label' | translate"
						[attr.title]="'task-details_add_video_instructions_aria_label' | translate"
						(click)="openLibrary()">
						<span
							class="instructions-editor-toolbar-action-label"
							translate="activity-editor-instructions_video-instructions">
						</span>
					</button>
				}

				@if (renderedMedia(); as mediaValue) {
					<div class="instructions-media instructions-media--inline">
						<ngx-media-thumbnail
							class="instructions-media-thumbnail"
							[media]="mediaValue">
						</ngx-media-thumbnail>

						<button
							type="button"
							class="instructions-media-title instructions-media-title-btn"
							(click)="openMediaPreviewModal(false)">
								{{mediaValue.title || 'common_untitled' | translate}}
						</button>
					</div>
				}

				@if (instructionTextLength() > CHARACTER_LIMIT) {
					<p
						class="error-text"
						role="alert"
						translate="activity-instructions-editor_form-validation-error-content-length"
						[translateParams]="{
							characterLimit: CHARACTER_LIMIT,
							charactersOverLimit: instructionTextLength() - CHARACTER_LIMIT
						}">
					</p>
				}
			</div>
		} @else {
			<div class="instructions-text" [innerHTML]="customInstructionsHtml() | sanitize"></div>

			@if (renderedMedia(); as mediaValue) {
				<div class="instructions-media">
					<ngx-media-thumbnail
						class="instructions-media-thumbnail"
						[media]="mediaValue">
					</ngx-media-thumbnail>

					<span
						class="instructions-media-title ellipsis">
							{{mediaValue.title || 'common_untitled' | translate}}
					</span>
				</div>
			}
		}

	</panel-body>
</ngx-panel>
